
<script>

</script>
<template>
    <div class="goods">
      <Scroll :height="scrollHeight">
        <!-- <van-nav-bar title="盘点列表" left-text="返回" right-text="重置" left-arrow @click-left="onSearch()" @click-right="onSearch()" /> -->
        <van-search
            v-show="!this.$route.query.searchKey"
            v-model="searchKey"
            placeholder="请输入搜索关键词"
            @search="onSearch"
            @blur="onSearch"
        />

        <van-divider />

        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <van-cell v-for="item in list" :key="item.id" >
                <van-card
                    :desc="`${item.department}`"
                    :title="`${item.name}-${item.mail}`"
                    :tag="item.sn_type"
                    :thumb="item.sn_type === '笔记本' ? img['laptop']: item.sn_type === '显示器' ? img['monitor']: item.sn_type === '电脑' ? img['physicalHost']: img['asset']"
                    >
                    <template #price>
                        <font size="4">{{ item.sn }}</font>
                    </template>
                    <template #tags>
                        <van-tag plain :type="item.status === '异常' ? 'danger': item.status === '新增' ? 'warning': 'success'">{{item.status}}</van-tag>
                        <van-tag plain>{{item.inventory_date}}</van-tag>
                    </template>
                </van-card>
            </van-cell>
            </van-list>
        </van-pull-refresh>

      </Scroll>

    </div>
</template>
<script>
import { Button, Form, Field, NavBar, Popup, Picker, Checkbox, Icon, Toast, Divider, Notify, Steps, Step, Tag, List, Cell, CheckboxGroup, Tab, Tabs, Dialog, Card, Search } from 'vant'
import { getAssetInventoryInformation } from '@/api/cmdb'
import monitorPic from '@/assets/images/asset-monitor.png'
import laptopPic from '@/assets/images/laptop.png'
import physicalHostPic from '@/assets/images/physicalHost.png'
import assetPic from '@/assets/images/asset.png'
import { getToken } from '@/libs/util'
import 'vant/lib/index.css';
export default {
  components: { [Button.name]: Button,  [Form.name]: Form,  [Field.name]: Field, [NavBar.name]: NavBar, [Popup.name]: Popup,  [Picker.name]: Picker,  [Checkbox.name]: Checkbox,  [Icon.name]: Icon, [Divider.name]: Divider,
                  [Steps.name]: Steps, [Step.name]: Step, [Tag.name]: Tag , [List.name]: List, [Cell.name]: Cell, [CheckboxGroup.name]: CheckboxGroup, [Tab.name]: Tab, [Tabs.name]: Tabs, [Dialog.Component.name]: Dialog.Component, [Card.name]: Card, [Search.name]: Search },
  data () {
    return {
        scrollHeight: 0,
        list: [],
        loading: false,
        finished: false,
        refreshing: false,
        page: 1,
        searchKey: '',
        img:{monitor:monitorPic, laptop: laptopPic, physicalHost:physicalHostPic, asset: assetPic}
    }
  },

  mounted () {
    if (!getToken() && this.$route.query.token !== 'searchAuGroup') {
      this.$router.push({
        path: '/401'
      })
    }
    this.scrollHeight = window.innerHeight
    const { searchKey } = this.$route.query
    this.searchKey = searchKey
  },
  methods: {
    toggle(index) {
      this.$refs.checkboxes[index].toggle()
    },
    getAssetInventoryInformation(){
        getAssetInventoryInformation({page: this.page, size:20, searchKey: this.searchKey}).then(rsp => {
        const { data, total } = rsp.data.data
        data.forEach(_a => {
            this.list.push(_a)
        });
        // 加载状态结束
        this.loading = false
        if (this.page >= total) {
          this.finished = true
        }
        this.page += 1
      })
    },
    onLoad() {
        setTimeout(() => {
            if (this.refreshing) {
                this.list = [];
                this.refreshing = false;
            }
            this.getAssetInventoryInformation()
        }, 500);

    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    onSearch(){
        setTimeout(() => {
            this.list = []
            this.page = 1
            this.finished = false
            this.loading = true
            this.onLoad()
        }, 500);

    }
  },

}

</script>

<style scoped>
::v-deep.van-field__control::-webkit-input-placeholder {
    font-size: 100px;
}
</style>

</script>
<style lang="less">
.goods {
  padding-bottom: 50px;

  &-swipe {
    img {
      width: 100%;
      display: block;
    }
  }

  &-title {
    font-size: 16px;
  }

  &-price {
    color: #f44;
  }

  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }

  &-cell-group {
    margin: 15px 0;

    .van-cell__value {
      color: #999;
    }
  }

  &-tag {
    margin-left: 5px;
  }
}
</style>
